import { ThreadListItem } from "@/component/ThreadListItem";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { communityStore } from "@/store/community";
import { getThreadSharePath } from "@/util/share";
import { observer } from "mobx-react-lite";
import Link from "next/link";
import { useEffect } from "react";
import { ThreadListSkeletonGrid } from "./ThreadListSkeletonGrid";

export const CommunitySection = observer(() => {
  const threads = communityStore.threads;
  const loading = communityStore.loading;

  const { is2xl, isXl, isLg, isMd, isSm } = useBreakpoints();

  let visibleCount = 2;
  if (is2xl) visibleCount = 5;
  else if (isXl) visibleCount = 4;
  else if (isLg || isMd) visibleCount = 3;
  else if (isSm) visibleCount = 2;

  useEffect(() => {
    communityStore.fetchCommunityThreads();
  }, []);

  if (loading && threads.length === 0) {
    return (
      <section>
        <ThreadListSkeletonGrid count={visibleCount} />
      </section>
    );
  }

  if (threads.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col gap-5">
      <h2 className="text-black font-bold text-xl">From the community</h2>
      <div className="grid-thread">
        {threads.map((thread) => {
          if (!thread.id) {
            return null;
          }

          return (
            <Link
              href={getThreadSharePath(thread.id)}
              key={thread.id}
              className="block p-0 border-0 bg-transparent cursor-pointer text-left"
            >
              <ThreadListItem thread={thread} />
            </Link>
          );
        })}
      </div>
    </section>
  );
});
